import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  0%, 20%, 40%, 60%, 80%, 100% {\n    transform: rotate(-4deg);\n  }\n\n  10%, 30%, 50%, 70%, 90% {\n    transform: rotate(4deg);\n  }\n'], ['\n  0%, 20%, 40%, 60%, 80%, 100% {\n    transform: rotate(-4deg);\n  }\n\n  10%, 30%, 50%, 70%, 90% {\n    transform: rotate(4deg);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: relative;\n  flex-shrink: 0;\n  border-radius: ', ';\n  height: ', 'px;\n  ', ' ', ';\n'], ['\n  position: relative;\n  flex-shrink: 0;\n  border-radius: ', ';\n  height: ', 'px;\n  ', ' ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n      animation: ', ' 0.82s linear infinite;\n      backface-visibility: hidden;\n      perspective: 1000px;\n    '], ['\n      animation: ', ' 0.82s linear infinite;\n      backface-visibility: hidden;\n      perspective: 1000px;\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n  opacity: ', ';\n  background-image: url("', '");\n  background-size: cover;\n  border-radius: ', ';\n  flex-shrink: 0;\n  width: ', 'px;\n  height: ', 'px;\n  ', '\n'], ['\n  opacity: ', ';\n  background-image: url("', '");\n  background-size: cover;\n  border-radius: ', ';\n  flex-shrink: 0;\n  width: ', 'px;\n  height: ', 'px;\n  ', '\n']);

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css, keyframes } from 'styled-components';
import { DefaultPicture } from './..';

var UserPicture = function (_Component) {
  _inherits(UserPicture, _Component);

  function UserPicture() {
    _classCallCheck(this, UserPicture);

    return _possibleConstructorReturn(this, (UserPicture.__proto__ || Object.getPrototypeOf(UserPicture)).apply(this, arguments));
  }

  _createClass(UserPicture, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          src = _props.src,
          backgroundColor = _props.backgroundColor,
          iconColor = _props.iconColor,
          showDefaultIcon = _props.showDefaultIcon,
          borderRadius = _props.borderRadius,
          style = _props.style,
          border = _props.border,
          size = _props.size,
          sizeDefault = _props.sizeDefault,
          shake = _props.shake,
          opacity = _props.opacity;


      return React.createElement(
        Container,
        {
          className: 'user-picture ' + className,
          borderRadius: borderRadius,
          size: src ? size : sizeDefault || size,
          style: style,
          shake: shake },
        src ? React.createElement(Image, {
          className: 'user-image',
          src: src,
          size: size,
          border: border,
          borderRadius: borderRadius,
          opacity: opacity
        }) : React.createElement(DefaultPicture, {
          className: 'default-picture',
          border: border,
          borderRadius: borderRadius,
          backgroundColor: backgroundColor,
          iconColor: iconColor,
          showIcon: showDefaultIcon,
          size: sizeDefault || size,
          opacity: opacity
        }),
        this.props.children
      );
    }
  }]);

  return UserPicture;
}(Component);

UserPicture.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  src: PropTypes.string,
  borderRadius: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  iconColor: PropTypes.string,
  showDefaultIcon: PropTypes.bool,
  style: PropTypes.object,
  border: PropTypes.string /* ie: 1px solid white */
  , size: PropTypes.number.isRequired,
  sizeDefault: PropTypes.number,
  shake: PropTypes.bool,
  opacity: PropTypes.number
};
UserPicture.defaultProps = {
  borderRadius: '50%',
  size: 32,
  opacity: 1
};


export default UserPicture;

var shakeAnimation = keyframes(_templateObject);

var Container = styled.div(_templateObject2, function (props) {
  return props.borderRadius;
}, function (props) {
  return props.size;
}, function (props) {
  return props.style;
}, function (_ref) {
  var shake = _ref.shake;
  return shake && css(_templateObject3, shakeAnimation);
});

var Image = styled.div(_templateObject4, function (props) {
  return props.opacity;
}, function (props) {
  return props.src;
}, function (props) {
  return props.borderRadius;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.border && 'border: ' + props.border + ';';
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/UserPicture/index.js
// module id = 421
// module chunks = 0